(function () {
  function hideElement(id) {
    let element = document.getElementById(id);
    if (element) {
      element.style.display = "none";
    }
  }
  function setCookie(name, value, days) {
    let expires = "";
    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }
  function disableScrolling() {
    document.getElementsByTagName("body")[0].style.overflow = "hidden";
  }

  function enableScrolling() {
    document.getElementsByTagName("body")[0].style.overflow = "auto";
  }

  if (document.getElementById("newsletter-popup")) {
    setTimeout(() => {
      document.getElementById("newsletter-popup").style.display = "flex";
      setCookie("newsletterPopup", "test", 7);
      disableScrolling();
    }, 3000);
  }

  if (document.getElementById("close-popup-newsletter")) {
    document
      .getElementById("close-popup-newsletter")
      .addEventListener("click", function () {
        document.getElementById("newsletter-popup").style.display = "none";
        enableScrolling();
      });
  }

  window.hideElement = hideElement;
  //open mobile drawer
  document
    .getElementById("openDrawerIcon")
    .addEventListener("click", function () {
      const drawer = document.getElementsByClassName("mobile-drawer")[0];
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
      drawer.classList.add("open");
    });

  //close mobile drawer
  document
    .getElementById("closeDrawerIcon")
    .addEventListener("click", function () {
      const drawer = document.getElementsByClassName("mobile-drawer")[0];
      document.getElementsByTagName("body")[0].style.overflow = "auto";
      drawer.classList.remove("open");
    });
})();
class Accordion {
  constructor(selector) {
    this.container = document.querySelector(selector);
    this.headers = this.container?.querySelectorAll(".accordion-header");

    this.headers?.forEach((header) => {
      header.addEventListener("click", () => {
        this.toggle(header);
        header.classList.toggle("is-closed");
      });
    });
  }

  toggle(header) {
    const content = header.nextElementSibling;

    if (content.style.maxHeight) {
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }

    // Close other panels
    this.headers.forEach((h) => {
      if (h !== header) {
        const otherContent = h.nextElementSibling;
        otherContent.style.maxHeight = null;
      }
    });
  }
}

const accordion = new Accordion(".accordion");

class Drawer extends HTMLElement {
  constructor() {
    super();
    this.btnOpen = this.querySelector(".js-open-drawer");
    this.overlay = document.createElement("div");
    this.overlay.classList.add("drawer-overlay");
    this.appendChild(this.overlay);
    this.btnClose = document.createElement("button");
    this.btnClose.classList.add("js-close-drawer");
    this.btnClose.setAttribute("aria-label", "Close mini cart");
    this.btnClose.innerHTML = `<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.5 8.8125L21.1875 7.5L15 13.6875L8.8125 7.5L7.5 8.8125L13.6875 15L7.5 21.1875L8.8125 22.5L15 16.3125L21.1875 22.5L22.5 21.1875L16.3125 15L22.5 8.8125Z" fill="black"/></svg>`;
    this.drawer = this.querySelector(".js-drawer");
    this.drawer.appendChild(this.btnClose);
  }

  connectedCallback() {
    if (this.btnClose && this.drawer) {
      const openDrawer = (e) => {
        this.drawer.classList.add("is-open");
        document.documentElement.style.overflow = "hidden";
        e.preventDefault();
      };

      const closeDrawer = (e) => {
        this.drawer.classList.remove("is-open");
        document.documentElement.style.overflow = "auto";
        e.preventDefault();
      };

      this.btnOpen?.addEventListener("click", openDrawer);
      this.btnClose?.addEventListener("click", closeDrawer);
      this.overlay?.addEventListener("click", closeDrawer);
    }
  }
}
customElements.define("sidebar-drawer", Drawer);

// search script
document.getElementById("search-icon") &&
  document
    .getElementById("search-icon")
    .addEventListener("click", function (e) {
      let searchBar = document.getElementsByClassName("search-bar").item(0);
      searchBar.classList.toggle("toggle-search");
      searchBar.querySelector("#search-input").value = "";
      searchBar.querySelector("#search-input").focus();
    });

document.querySelector("header.mobile #search-icon") &&
  document
    .querySelector("header.mobile #search-icon")
    .addEventListener("click", function (e) {
      let searchBar = document.getElementsByClassName("search-bar").item(1);
      searchBar.classList.toggle("toggle-search");
      searchBar.querySelector("#search-input").value = "";
      searchBar.querySelector("#search-input").focus();
    });

    document.querySelector("header.desktop  #close-search") &&
     document
       .querySelector("header.desktop  #close-search")
       .addEventListener("click", function (e) {
       e.target.closest('header').style.zIndex = "auto";
       e.target.closest('.search-bar').classList.toggle("toggle-search");
       });

var details = [...document.querySelectorAll("details")];
document.addEventListener("click", function (e) {
  if (!details.some((f) => f.contains(e.target))) {
    details.forEach((f) => f.removeAttribute("open"));
  } else {
    details.forEach((f) =>
      !f.contains(e.target) ? f.removeAttribute("open") : ""
    );
  }
});
const detailsSummaries = document.querySelectorAll('.menu-item summary');
detailsSummaries.forEach(summary => {
  summary.addEventListener('mouseover', () => {
    detailsSummaries.forEach(sum => {sum.parentElement.open = false})
    summary.parentElement.open = true;
  });
  // summary.addEventListener('mouseout', () => {
  //   summary.parentElement.open = false;
  // });
});
window.addEventListener('scroll',()=>{
  const scrollPosition = window.scrollY || window.scrollY;
  if (scrollPosition > 250) {
    detailsSummaries.forEach(sum => {sum.parentElement.open = false})
  }
  
})

